export default __webpack_public_path__ + "static/media/AtomsAndCompounds _23.1431fe29.png";